export default __webpack_public_path__ + "static/media/Kothian Battle Bracers.7abe54ed.jpg";